import { useState, useContext, useEffect } from "react";
import styled from "styled-components";
import { Colors, Spacing } from "@paclife/plds.tokens";

import { AppContext } from "context/AppContext";

import Typography from "common/Typography/Typography";
import OverflowMenu from "common/OverflowMenu/OverflowMenu";

import MFAModal from "components/MFAModal/MFAModal";
import MFAStatus from "components/MFAStatus/MFAStatus";
import { useTranslation } from "react-i18next";

const Wrapper = styled.div`
    display: flex;
    margin-bottom: ${Spacing[32]};
`;

const Label = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: ${Spacing[8]};
`;

const Text = styled(Typography)`
    display: block;
    color: ${({ color }) => color};
    &.label-text {
        margin-right: ${Spacing[4]};
    }
`;

const PrimaryEmail = () => {
    const { t } = useTranslation("loginSecurity");
    const {
        account: { primaryEmail, factors }
    } = useContext(AppContext);
    
    const [editModal, setEditModal] = useState(false);
    const [status, setStatus] = useState(false);
    const [factorId, setFactorId] = useState("");
    

    useEffect(() => {        
        if (factors !== undefined) {
           getEmailStatus(factors);
        } 
    }, [factors]);

    const getEmailStatus = (data) => {
        let sts = "";
        let fid = "";
        if (data.length > 0) {
            //data.every((factor) => {
            data.forEach(({ factorType, status, id }) => {
                if (factorType === "primaryemail") { 
                    sts = status;
                    fid = id;
                    return false;
                } 
                return true;
            });
            setStatus(sts);
            setFactorId(fid);
        }
    }

    const openEditModal = () => {
        setEditModal(true);
    };

    const closeMFAModal = () => {
        setEditModal(false);
    };

    const menu = [
        {
            icon: "edit",
            color: Colors.neutral1000,
            action: "Update",
            onClick: openEditModal
        }
    ];

    return (
        <>
            <Wrapper>
                <OverflowMenu
                    icon={status !== "ACTIVE" ? "overflowMenuVertical" : "edit"}
                    color={Colors.blue600}
                    onClick={openEditModal}
                    menu={menu}
                />
                <div>
                    <Label>
                        <Text
                            className="label-text"
                            variant="caption"
                            display="block"
                            color={Colors.textBodyLight}
                            bold
                        >
                            {t("email.primary")}
                        </Text>
                    </Label>
                    <Text color={Colors.textBodyLight}>{primaryEmail}</Text>
                    <MFAStatus status={status} />
                </div>
            </Wrapper>

            {(editModal) && (
                <>
                    <MFAModal
                        closeModal={ closeMFAModal }
                        factorType="email"
                        factorId={factorId}
                        subType="primary"
                        defaultValue={primaryEmail}
                        defaultScreen={"update"}
                    />
                </>
            )}
        </>
    );
};

export default PrimaryEmail;